import coreAttributes from "./core.json";
import calculatorAttributes from "./calculator.json";
import legendAttributes from "./legend.json";
import sidebarAttributes from "./sidebar.json";

export default {
  ...coreAttributes,
  ...calculatorAttributes,
  ...legendAttributes,
  ...sidebarAttributes,
};
